import {StyleSheet} from 'react-native';

import {rose} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    position: 'relative',
  },
  indicator: {
    position: 'absolute',
    borderStyle: 'solid',
    borderColor: rose,
  },
  indicatorTop: {
    borderBottomWidth: 1,
  },
  indicatorBottom: {
    borderTopWidth: 1,
  },
  indicatorLeft: {
    borderRightWidth: 1,
  },
  indicatorRight: {
    borderLeftWidth: 1,
  },
});
